<template>
  <base-modal overlay-class="mini_games_modal">
    <div class="modal__body">
      <template v-if="successful">
        <h1>{{ getTranslations.modal_post_game_puzzle_success_title }}</h1>
        <p>{{ getTranslations.modal_post_game_puzzle_success_subtitle }}</p>
      </template>

      <template v-else>
        <h1>{{ getTranslations.modal_post_game_puzzle_failed_title }}</h1>
        <p>{{ getTranslations.modal_post_game_puzzle_failed_subtitle }}</p>
      </template>

      <base-image src="/static/images/puzzle/puzzle_sign.svg" image-class="modal_icon_main" alt="puzzle icon" />
    </div>

    <div class="modal__footer">
      <template v-if="successful">
        <p>{{ getTranslations.modal_post_game_puzzle_success_you_earned }}</p>
        <div class="reward_points">+{{ prizeValue }} {{ getTranslations.modal_post_game_puzzle_success_reward }}</div>
      </template>

      <template v-else>
        <p>
          {{ getTranslations.modal_post_game_puzzle_failed_description_pt1 }}<br>
          {{ getTranslations.modal_post_game_puzzle_failed_description_pt2 }}
        </p>
      </template>

      <a
        href="#"
        class="ti_btn--main close_modal"
        @click.prevent
      >
        {{ getTranslations.modal_post_game_puzzle_button_proceed }}
      </a>
    </div>
  </base-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseModal from '../../../../common/modal/BaseModal.vue';
import BaseImage from '../../../../common/image/BaseImage.vue';

export default {
  name: 'PostGamePuzzleModal',
  components: {
    BaseModal,
    BaseImage,
  },
  props: {
    successful: {
      type: Boolean,
      default: false,
    },
    prizeValue: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/addOnGame/components/PostGamePuzzleModal.vue